import { Fragment, FunctionComponent, MutableRefObject, ReactNode } from 'react';
import { Panel } from '@/components/common/panel/panel';
import { ProductTypeAppearances } from './ProductTypeAppearances';
import { ProductTypeAttributes } from './ProductTypeAttributes';
import { ProductTypeInfo } from './ProductTypeInfo';
import './ProductTypePanel.scss';

interface ProductTypePanelProps {
  active?: boolean;
  panelRef?: MutableRefObject<HTMLDivElement | null>;
  toggle: ReactNode;
  children: ReactNode;
}

export type ProductTypePanelComponent = FunctionComponent<ProductTypePanelProps>;

export const ProductTypePanel: ProductTypePanelComponent = ({
  active = true,
  panelRef,
  toggle,
  children,
}) => (
  <Fragment>
    <Panel hidden={!active} ref={panelRef}>
      <ProductTypeInfo />
      <ProductTypeAppearances />
      <ProductTypeAttributes />
      {toggle}
    </Panel>
    {children}
  </Fragment>
);
